import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
import menuRouters from '../router/menu-router';
import createPersistedState from "vuex-persistedstate"

export default new Vuex.Store({
	plugins: [createPersistedState()],// 缓存state
	state: {
		token: '',//token
		menuList: [],// 菜单列表
		curMenuList: [],// 菜单列表
		curMainMenuList: [],// 菜单列表
		menuCollapse:false,
		curMenuRouter: '',// 当前选中一级菜单
		curMenuOpened: [],// 当前展开二级菜单
		editId: '',// 编辑的对象ID
		userType: '', //编辑的对象类型
		breadCrumbList: [],// 面包屑配置列表
		supplierCheckInfo:{},// 审核服务商跳转时传值
		userInfo:{},//当前用户信息
		corpNo:'',//公司编号
		curUserMenuList:[],// 当前用户菜单列表
		curUserAuthList:[],// 当前用户菜单列表
		financeManageDealer:{},//入账审核/财务审核 页面使用到的运营商数据
		stationObj:{},//电站管理 资费 使用的
		bannerObj:{},
		curSelChargeCardInfo:{},// 当前选择的充点卡信息
		curAppH5Info:{},// 当前用户信息
		cardDetailBack:'',
		pileObj:{},//用户详情查看跳转时传值
		custObj:{},//充电桩详情查看跳转时传值
		editObj:{}, //编辑对象
	},
	mutations: {
		setCurAppH5Info(state, curAppH5Info) {
			state.curAppH5Info = curAppH5Info;
		},
		setCardDetailBack(state, cardDetailBack) {
			state.cardDetailBack = cardDetailBack;
		},
		setCurSelChargeCardInfo(state, curSelChargeCardInfo) {
			state.curSelChargeCardInfo = curSelChargeCardInfo;
		},
		setCurUserMenuList(state, curUserMenuList) { //1
			state.curUserMenuList = curUserMenuList;
		},
		setCurMainMenuList(state, curMainMenuList) {
			state.curMainMenuList = curMainMenuList;
		},
		setCurUserAuthList(state, curUserAuthList) {
			state.curUserAuthList = curUserAuthList;
		},
		updateMenuList(state, menuList) {
			state.menuList = menuRouters;
		},
		updateCurMenuListList(state, curMenuList) {
			state.curMenuList = curMenuList;
		},
		// 设置token
		setToken(state, token) {
			state.token = token;
		},
		setCorpNo(state, corpNo) {
			state.corpNo = corpNo;
		},
		setUserInfo(state, userInfo) {
			state.userInfo = userInfo;
		},
		//充电桩编号
		setPileNo(state, pileNo) {
			state.pileNo = pileNo;
		},
		// 设置当前的选中的页面菜单
		setCurMenuRouter(state, curMenuRouter) {
			state.curMenuRouter = curMenuRouter;
		},
		// 设置当前的展开的页面菜单
		setCurMenuOpened(state, curMenuOpened) {
			state.curMenuOpened = curMenuOpened;
		},
		// 设置菜单的展开收起
		setMenuCollapse(state, menuCollapse) {
			state.menuCollapse = menuCollapse;
		},
		// 编辑的对象ID
		setEditId(state, editId) {
			state.editId = editId;
		},
		setStationNo(state, stationNo) {
			state.stationNo = stationNo;
		},
		// 编辑的对象类型
		setUserType(state, userType) {
            state.userType = userType;
		},
		setBreadCrumbList(state, breadCrumbList){
			state.breadCrumbList = breadCrumbList;
		},
		setSupplierCheckInfo(state, supplierCheckInfo){
			state.supplierCheckInfo = supplierCheckInfo;
		},
		setFinanceManageDealer(state, financeManageDealer){
			state.financeManageDealer = financeManageDealer;
		},
		setStationObj(state, stationObj){
			state.stationObj = stationObj;
		},
		setCustObj(state, custObj){
			state.custObj = custObj;
		},
		setPileObj(state, pileObj){
			state.pileObj = pileObj;
		},
		setEditObj(state, editObj){
			state.editObj = editObj;
		},
	},
	actions: {
	},
	modules: {
	}
})
